var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPipeline = function SvgPipeline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 81,
    viewBox: "0 0 119 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipeline_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "pipeline_svg__export",
    transform: "translate(-236 -378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pipeline_svg__pipeline",
    transform: "translate(235 376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pipeline_svg__icon-process",
    transform: "rotate(-18 43.009 13.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pipeline_svg__Path-3",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M44.118 20.139h49.95c10.494 0 19 8.506 19 19h0c0 10.542-8.456 19.136-18.997 19.307l-74.91 1.21c-10.04.162-18.093 8.347-18.093 18.387h0c0 9.994 8.102 18.096 18.095 18.096h49.105"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pipeline_svg__Rectangle",
    width: 39,
    height: 39,
    x: 0.915,
    y: 0.969,
    fill: "#80A6D6",
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pipeline_svg__Rectangle",
    width: 39,
    height: 39,
    x: 77.075,
    y: 77.236,
    fill: "#386DB0",
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "pipeline_svg__Path-4",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m54.624 107.394 14-11.5-14-11.5"
  })))))));
};
export default SvgPipeline;